const vip = () => import(/* webpackChunkName: "vip" */'@/page/vip/vip')
const vipDetail = () => import(/* webpackChunkName: "vip" */'@/page/vip/detail')

const vipRouter = [{
    path: 'vip',
    name: 'vip',
    component: vip
}, {
    path: '/vip/detail',
    name: 'vipDetail',
    component: vipDetail
}]

export default vipRouter


// WEBPACK FOOTER //
// ./src/router/vip.js